import { render, staticRenderFns } from "./SelectButton.vue?vue&type=template&id=5c300c04&scoped=true&"
import script from "./SelectButton.vue?vue&type=script&lang=js&"
export * from "./SelectButton.vue?vue&type=script&lang=js&"
import style0 from "./SelectButton.vue?vue&type=style&index=0&id=5c300c04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c300c04",
  null
  
)

export default component.exports